class FaqScript{
    constructor(){
       
        this.events()

    }

    events(){
        const toggles = document.querySelectorAll('.faq-toggle')
        toggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                toggle.parentNode.classList.toggle('active')
            })
        })
        
    }
}

export default FaqScript;